import { removeListFromList, unique } from "../lib/util";
export const geometryMutations = {
    addGeometries(state, payload) {
        const combined = state.allGeometries.concat(payload);
        state.allGeometries = unique(combined);
        return true;
    },
    selectGeometries(state, payload) {
        const combined = state.selectedGeometries.concat(payload);
        state.selectedGeometries = unique(combined);
        return true;
    },
    unselectGeometries(state, payload) {
        state.selectedGeometries = removeListFromList(payload, state.selectedGeometries);
        return true;
    },
    setSelectedGeometries(state, payload) {
        state.selectedGeometries = payload;
        return true;
    },
};
export const jobMutations = {
    setJobs(state, payload) {
        state.allJobs = payload;
        return true;
    },
    setJobLocationAll(state, payload) {
        state.jobLocationsAll = payload;
        return true;
    },
    setJobLocation(state, payload) {
        state.jobLocations = payload;
        return true;
    },
    addJobLocation(state, payload) {
        const combined = state.jobLocations.concat(payload);
        state.jobLocations = unique(combined);
        return true;
    },
    setVisibleJobs(state, payload) {
        state.visibleJobs = payload;
        return true;
    },
    addVisibleJobs(state, payload) {
        const combined = state.visibleJobs.concat(payload);
        state.visibleJobs = unique(combined);
        return true;
    },
    setSelectedJobs(state, payload) {
        state.selectedJobs = payload;
        return true;
    },
    setSelectedLocation(state, payload) {
        state.selectedLocation = payload;
        return true;
    },
};
export const mutations = Object.assign(Object.assign({}, geometryMutations), jobMutations);
